import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55db2c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }
const _hoisted_2 = {
  key: 0,
  class: "app__center-info center"
}
const _hoisted_3 = {
  key: 1,
  class: "app__center-info center error-color"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "app__topBlock" }

import { useAppStore } from '@/store/modules/app';
import { onBeforeMount, onMounted, onUnmounted, ref } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { useRoute } from 'vue-router';
import {
  AlertModal,
  AuthModal,
  FooterComponent,
  HeaderComponent,
  Messenger,
  MobileDownMenu,
} from '@/components';
import { useCompareStore } from '@/store/modules/compare';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { ClearStateAndStorage } from '@/utils/Common/ClearStateAndStorage';
import { NotFound } from '@/views';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const onResize = () => {
  useAppStore().writeWindowWidth(window.innerWidth);
  let vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

window.addEventListener('resize', onResize);
window.addEventListener('storage', async function (event) {
  if (event.key == 'auth-event') {
    ClearStateAndStorage();
    location.reload();
  }
});
onResize();

document.addEventListener(
  'DOMContentLoaded',
  function () {
    function hasTouchDevice() {
      return !!('ontouchstart' in window || navigator.maxTouchPoints);
    }

    if (!hasTouchDevice()) {
      document.body.classList.add('no-touch');
    } else {
      document.body.classList.add('touch');
    }
  },
  { passive: true },
);

const loadingApp = ref(true);
const infoError = ref(false);

onBeforeMount(() => {
  const baseUrl = window.location.origin;

  useAppStore().changeBaseUrl(baseUrl);
});
const route = useRoute();

onMounted(async () => {
  try {
    loadingApp.value = true;
    await useAppStore().getInfo();
    await useUserStore().getUserInfo();
    if (!useUserStore().user) {
      useCompareStore().getCompareFromLocalStorage();
    }
    useOfferCardsStore().getViewedAdsFromLocalStorage();
  } catch (error) {
    infoError.value = true;
  } finally {
    loadingApp.value = false;
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', onResize);
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_base_up_button = _resolveComponent("base-up-button")!
  const _component_base_overlay = _resolveComponent("base-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loadingApp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_base_spinner, {
            size: 50,
            color: "#009D3E"
          })
        ]))
      : (infoError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Ошибка загрузки "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.$route.meta.withoutNav)
                ? (_openBlock(), _createBlock(_unref(HeaderComponent), { key: 0 }))
                : _createCommentVNode("", true),
              (_unref(useAppStore)().isPageNotFound)
                ? (_openBlock(), _createBlock(_unref(NotFound), { key: 1 }))
                : (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
            ]),
            _createVNode(_component_base_up_button),
            (!_ctx.$route.meta.withoutNav)
              ? (_openBlock(), _createBlock(_unref(FooterComponent), { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_unref(MobileDownMenu)),
            (_unref(useAppStore)().showAuthModal || _unref(useRoute)()?.name === 'passwordRestore')
              ? (_openBlock(), _createBlock(_unref(AuthModal), { key: 1 }))
              : _createCommentVNode("", true),
            _createVNode(_unref(AlertModal)),
            _createVNode(_unref(Messenger), { "is-mini": "" })
          ])),
    _createVNode(_component_base_overlay, {
      value: _unref(useAppStore)().overlay,
      class: "main__z-index"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_base_spinner, { size: 50 })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})